<template>
  <div>
    <div class="card mat10">
      <div class="flex-s-s" style="position: relative;">
        <img :src="detail.photo" class="img" />
        <div style="margin-left:20px">
          <div class="title">{{detail.activityName}}</div>
          <ul class="key-value">
            <li v-for="item in messageList">
              <div class="key">{{item.key}}：</div>
              <div class="value">{{item.value}}</div>
            </li>
          </ul>
          <img src="@images/detailEnd.png" class="status" v-if="detail.status==1" />
          <img src="@images/starting.png" class="status" v-else />
          <!-- 1报名已满或已过报名时间 2已报名 3未报名 -->
        </div>
      </div>
      <div class="fontcolor-grey mat20"> 活动说明：</div>
      <div class="mat10" style="line-height:30px" v-html="detail.remark"> </div>
      <template v-if="$route.params.type==3&&userMess.applyPost!==3">

      </template>
      <template v-else>
        <el-button type="primary" style="width:100px;margin: 100px 0 0 300px" v-show="detail.status==3" @click="signUp">报名</el-button>
        <el-button type="primary" disabled style="width:100px;margin: 100px 0 0 300px" v-show="detail.status==1">报名结束</el-button>
        <el-button type="primary" disabled style="width:100px;margin: 100px 0 0 300px" v-show="detail.status==2">已报名</el-button>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      messageList: [],
      userMess: this.$store.state.user.user,
      detail: {}
    };
  },
  computed: {},
  watch: {},
  methods: {
    getDetail() {
      let params = {
        taskId: this.$route.params.id,
        volunteerId: this.userMess.id
      }
      this.$api.showActivityDetail(params).then(res => {
        this.detail = res.data
        this.messageList = [
          { key: "发布时间", value: res.data.createTime },
          { key: " 编号", value: res.data.number },
          { key: " 类型 ", value: res.data.activityType },
          { key: "活动日期 ", value: res.data.startDate },
          { key: "活动时间 ", value: res.data.startTime },
          { key: "招募人数", value: res.data.applyNumber + '/' + res.data.recruitNumber + "人" },
          { key: "报名截止", value: res.data.registrationDeadline }
        ]
        // console.log(res)
      })
    },
    signUp() {
      let _this = this
      this.$confirm({
        title: "报名",
        content: "<p>活动日期：" + this.detail.startDate + "</p><p>活动时间：" + this.detail.startTime + "</p>",
        // head: '您不满足申请解锁资格！',
        confirm: true,
        cancel: true,
        dialogVisible: true,
        btn: {
          confirmVal: "确定",
          cancelVal: "取消"
        }
      }).then((res) => {
        // console.log("sssss")
        // console.log("yes", res);
        let params = {
          activityType: _this.$route.params.type,
          ids: _this.$route.params.id,
          volunteerId: _this.userMess.id
        }
        _this.$api.drawTask(params).then(res => {
          if (res.code == 1) {
            _this.$message.success(res.message);
            _this.getDetail()
          } else {
            _this.$message.error(res.message);
          }
        })
        //点击确定之后的处理
      }).catch((err) => {
        // console.log("no", err);
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getDetail()
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
.img {
  width: 500px;
  height: 312.5px;
}
.title {
  font-size: 22px;
}
.status {
  width: 80px;
  height: 80px;
  position: absolute;
  top: 40px;
  right: 10px;
}
</style>
